import React, { useState, useEffect, useReducer } from 'react'
import {
  deletePointFromModal,
  addTempMarkAction,
  deleteErrorsAction,
} from '../../../../redux/actions/coordinates'
import { connect } from 'react-redux'
import ReactPlayer from 'react-player/lazy'
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Input,
  Checkbox,
  ListItemText,
  Grid,
} from '@material-ui/core/'
import { makeStyles } from '@material-ui/core/styles'
import style from './Common.module.css'
import modalStyles from '../index.module.scss'
import ImageUploader from 'react-images-upload'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import styles from './Common.module.css'
import DeleteForeverTwoToneIcon from '@material-ui/icons/DeleteForeverTwoTone'
import {
  isInvalidIOSSize,
  calculateIOSCanvasSize,
  replaceCoordinates,
} from '../../../../helpers/Canvas/size'
import { showTempMarkApi } from '../../../../api/marks/marks'
import axios from 'axios'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: '26px',
  },
  formControl: {
    margin: '0',
    width: '100%',
  },
  select: {
    marginBottom: '26px',
    position: 'relative',
  },
  textarea: {
    borderRadius: '10px',
    maxWidth: '100%',
    color: 'black',
    padding: '10px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    minHeight: '40px',
    width: '100%',
    paddingRight: '42px',
    border: '1px solid #c4c4c4',
  },
  errors: {
    border: '1px solid red',
  },
  relative: {
    position: 'relative',
  },
  absolute: {
    position: 'absolute',
    right: '4px',
    top: '15px',
    transition: 'all 0.5s',
    '&:hover': {
      transform: 'scale(1.2)',
      cursor: 'pointer',
    },
  },
  levelTag: {
    color: '#FC2A3A',
  },
  treesTag: {
    color: '#3BBDE3',
  },
}))

const EditMapContent = ({
  onClose,
  tags,
  clickedCoords,
  deletePointFromModal,
  map,
  addTempMarkAction,
  errors,
  deleteErrorsAction,
  temp_id,
}) => {
  const classes = useStyles()

  const markInitialState = {
    title: '',
    description: '',
    tag: '',
    videoLink: '',
  }

  const reducer = (state, { type, payload }) => {
    switch (type) {
      case 'title':
        return { ...state, title: payload }
      case 'description':
        return { ...state, description: payload }
      case 'tag':
        return { ...state, tag: payload }
      case 'videoLink':
        return { ...state, videoLink: payload }
      case 'clean':
        return markInitialState
      default:
        return state
    }
  }

  const [markForm, dispatch] = useReducer(reducer, markInitialState)

  const [isOpenConfirmation, setConfirmation] = useState(false)
  const [pictures, setPictures] = useState([])
  const [defaultPictures, setDefaultPictures] = useState([])
  const [savedPictures, setSavedPictures] = useState([])
  const [deletePictures, setDeletePictures] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const [videoLinks, setVideoLinks] = useState([{ link: '', id: Date.now() }])
  const [savedVideos, setSavedVideos] = useState([])

  const [fetchMarkCancelToken, setFetchMarkCancelToken] = useState(null)

  useEffect(() => {
    if (clickedCoords) {
      if (fetchMarkCancelToken) {
        fetchMarkCancelToken.cancel()
      }

      if (clickedCoords.id) {
        const cancelTokenSource = axios.CancelToken.source()
        setFetchMarkCancelToken(cancelTokenSource)
        showTempMarkApi(clickedCoords.id, cancelTokenSource.token)
          .then((res) => {
            if (res.data.item) {
              const { title, description, tags, media } = res.data.item
              dispatch({ type: 'title', payload: title || '' })
              dispatch({ type: 'description', payload: description || '' })

              if (tags && tags.length) {
                setSelectedTags(tags.map((t) => t.name))
              }

              if (media && media.length) {
                const videos = media.filter((m) => m.type === 1 && m.url)
                const images = media.filter((m) => m.type === 0)

                setVideoLinks(videos.map((v) => ({ link: v.url, id: v.id })))
                setSavedVideos(videos.map((v) => v.id))
                setDefaultPictures(images.map((i) => i.path_url))
                setSavedPictures(images)
              }
            } else {
              clear()
            }
          })
          .catch(() => {
            clear()
          })
          .finally(() => {
            setFetchMarkCancelToken(null)
          })
      }
    }
  }, [clickedCoords])

  const clear = () => {
    dispatch({ type: 'clean' })
    setConfirmation(false)
    setPictures([])
    setDefaultPictures([])
    setSavedPictures([])
    setDeletePictures([])
    setSavedVideos([])
  }

  const handleChange = (event) => {
    const { value, name } = event.target
    if (errors && errors[name]) {
      deleteErrorsAction(name)
    }
    dispatch({ type: name, payload: value })
  }

  const handleDeletePointAndClose = () => {
    deletePointFromModal(clickedCoords)
    closeModalHandler()
  }

  const renderConfirmationModal = isOpenConfirmation ? (
    <div className={modalStyles.confirmationModal}>
      <h2>Are you sure?</h2>
      <Button color="secondary" onClick={() => handleDeletePointAndClose()}>
        yes
      </Button>
      <Button onClick={() => setConfirmation(false)}>no</Button>
    </div>
  ) : null

  const submitHandler = () => {
    let i = 0

    const invalidIOSSize = isInvalidIOSSize(map.width, map.height)
    const mapSize = { width: Number(map.width), height: Number(map.height) }
    const calculatedSize = invalidIOSSize
      ? calculateIOSCanvasSize(map.width, map.height)
      : null
    const coords = invalidIOSSize
      ? replaceCoordinates(
          mapSize.width,
          mapSize.height,
          calculatedSize.width,
          calculatedSize.height,
          [clickedCoords.x, clickedCoords.y],
        )
      : [clickedCoords.x, clickedCoords.y]

    const formData = new FormData()
    formData.append('map_id', map.id)
    formData.append('temp_id', `${temp_id}`)
    formData.append('meta[type]', clickedCoords.type)
    formData.append('meta[radius]', clickedCoords.radius)
    formData.append('meta[x]', String(coords[0]))
    formData.append('meta[y]', String(coords[1]))
    formData.append('meta[color]', clickedCoords.color)

    if (markForm.title && markForm.title !== '') {
      formData.append('title', markForm.title)
    }

    if (markForm.description && markForm.description !== '') {
      formData.append('description', markForm.description)
    }

    if (markForm.tag && markForm.tag !== '') {
      formData.append('tag_id', markForm.tag)
    }

    if (videoLinks) {
      videoLinks
        .filter((v) => savedVideos.indexOf(v.id) < 0)
        .map((videoLink) => {
          if (videoLink.link !== 0) {
            i += 1
            formData.append(`media[${i}][type]`, 1)
            formData.append(`media[${i}][url]`, videoLink.link)
          }
        })
    }

    if (pictures) {
      for (let j = 0; j < pictures.length; j++) {
        i += 1
        if (pictures.length > 0 && pictures[j]) {
          formData.append(`media[${i}][type]`, 0)
          formData.append(`media[${i}][file]`, pictures[j])
        }
      }
    }

    if (deletePictures) {
      deletePictures.forEach((p) => {
        formData.append(`delete_media[]`, p)
      })
    }

    selectedTags.map((tag) => {
      for (let i = 0; i < tags.length; i++) {
        if (tag === tags[i].name) {
          formData.append(`tag_id[${i}]`, tags[i].id)
        }
      }
    })

    addTempMarkAction(
      formData,
      clickedCoords,
      closeModalHandler,
      markForm.title,
      clickedCoords.id,
    )
  }

  const onDrop = (files, pictures) => {
    setPictures(files)

    if (savedPictures.length) {
      const newDeletePictures = deletePictures.slice()
      savedPictures.forEach((p) => {
        if (pictures.indexOf(p.path_url) < 0) {
          newDeletePictures.push(p.id)
        }
      })
      setDeletePictures(newDeletePictures)
    }
  }

  const closeModalHandler = (close) => {
    clear()
    onClose(close)
  }

  const handleChangeTags = (e) => {
    setSelectedTags(e.target.value)
  }

  const handleDeleteTags = (event) => {
    const { name } = event.currentTarget
    const filteredTags = selectedTags.filter((el) => el !== name)
    setSelectedTags(filteredTags)
  }

  const renderTagsButtons = selectedTags.map((el) => (
    <button
      type="button"
      className={style.tag}
      key={el}
      name={el}
      onClick={(el) => handleDeleteTags(el)}
    >
      <span className={style.tagText}>{el}</span>
      <span className={style.iconClose}>X</span>
    </button>
  ))

  const handleChangeVideoLinks = (e, link) => {
    const VideoLinksCopy = videoLinks.slice()
    VideoLinksCopy.forEach((item) => {
      if (item.id === link.id) {
        item.link = e.target.value
      }
    })
    setVideoLinks(VideoLinksCopy)
  }

  const addLinkHandler = () => {
    const VideoLinksCopy = videoLinks.slice()
    VideoLinksCopy.push({ link: '', id: Date.now() })
    setVideoLinks(VideoLinksCopy)
  }

  const deleteLinkHandler = (link) => {
    const VideoLinksCopy = videoLinks.slice()
    if (savedVideos.indexOf(link.id) >= 0) {
      setDeletePictures([...deletePictures, link.id])
    }
    const newLinksData = VideoLinksCopy.filter((item) => item.id !== link.id)
    setVideoLinks(newLinksData)
  }

  const tagClassName = (name) =>
    /expert|beginner|intermediate/i.test(name)
      ? classes.levelTag
      : /(steep|mellow|dense|open) trees/i.test(name)
      ? classes.treesTag
      : ''

  return (
    <>
      <div className={style.wrapper}>
        {errors === 'Unauthenticated.' && (
          <div className={style.Unauthorized}>Registered users only!</div>
        )}
        <TextField
          className={classes.root}
          label="Title"
          variant="outlined"
          name="title"
          onChange={handleChange}
          value={markForm.title}
          error={errors && errors.title ? true : false}
          helperText={errors && errors.title ? errors.title[0] : ''}
        />
        <TextareaAutosize
          className={`${classes.textarea} ${
            errors && errors.description ? classes.errors : ''
          }`}
          rowsMin={3}
          name="description"
          placeholder="Enter your description"
          onChange={handleChange}
          value={markForm.description}
        />
        {errors && errors.description && errors.description[0] && (
          <div className={styles.Error}>{errors.description[0]}</div>
        )}

        <FormControl className={classes.formControl}>
          <InputLabel>Select Tags</InputLabel>
          <Select
            labelId="demo-mutiple-checkbox-label"
            multiple
            value={selectedTags}
            onChange={handleChangeTags}
            input={<Input />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
            className={errors && !errors.tag_id ? classes.select : ''}
            error={errors && errors.tag_id ? true : false}
          >
            {tags.map((tag) => (
              <MenuItem key={tag.id} value={tag.name}>
                <Checkbox checked={selectedTags.indexOf(tag.name) > -1} />
                <ListItemText
                  className={tagClassName(tag.name)}
                  primary={tag.name}
                />
              </MenuItem>
            ))}
          </Select>
          {errors && errors.tag_id ? (
            <div className={style.Errors}>{errors.tag_id[0]}</div>
          ) : null}
        </FormControl>
        <div className={style.checkButtons}>{renderTagsButtons}</div>
        <ImageUploader
          withIcon={true}
          className={style.ImgUploader}
          buttonText="Choose images"
          onChange={onDrop}
          imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
          maxFileSize={10242880}
          fileTypeError="is not supported file extension"
          withPreview={true}
          label="Max file size: 10mb, accepted: jpg|gif|png"
          defaultImages={defaultPictures}
        />

        {videoLinks.map((link) => {
          return (
            <React.Fragment key={link.id}>
              <Grid container className={classes.relative}>
                <TextField
                  className={`${classes.root}`}
                  label="Video Link"
                  variant="outlined"
                  name="videoLink"
                  onChange={(e) => handleChangeVideoLinks(e, link)}
                  value={link.link}
                  error={
                    link.link.indexOf('http://') === -1 &&
                    link.link.indexOf('https://') === -1 &&
                    link.link !== ''
                      ? true
                      : false
                  }
                  inputProps={{
                    style: {
                      paddingRight: 33,
                    },
                  }}
                  helperText={
                    link.link.indexOf('http://') === -1 &&
                    link.link.indexOf('https://') === -1 &&
                    link.link !== ''
                      ? 'Please enter valid data'
                      : ''
                  }
                />
                <Grid
                  item
                  className={classes.absolute}
                  onClick={() => deleteLinkHandler(link)}
                >
                  <DeleteForeverTwoToneIcon />
                </Grid>
              </Grid>

              {link.link &&
                (link.link.indexOf('https://') !== -1 ||
                  link.link.indexOf('http://') !== -1) && (
                  <ReactPlayer
                    style={{ marginBottom: '26px' }}
                    url={link.link}
                    width="100%"
                  />
                )}
            </React.Fragment>
          )
        })}
        <Grid container justify="flex-end">
          <Grid item>
            <Button onClick={addLinkHandler}>Add More Links</Button>
          </Grid>
        </Grid>
      </div>
      <div className={style.btnGroup}>
        <Button color="secondary" onClick={() => setConfirmation(true)}>
          Delete point
        </Button>
        <Button onClick={() => closeModalHandler(true)}>Cancel</Button>
        <Button onClick={submitHandler}>Save</Button>
        {renderConfirmationModal}
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    tags: state.general.tags,
    map: state.map.map,
    errors: state.newCoords.errors,
    temp_id: state.newCoords.temp_id,
  }
}

const mapDispatchToProps = {
  deletePointFromModal,
  addTempMarkAction,
  deleteErrorsAction,
}
export default connect(mapStateToProps, mapDispatchToProps)(EditMapContent)
